module.exports = __webpack_public_path__ + "media/images/BookSalon-da3b62a8d7e7290b8235b2f3036a1b90.jpg";